<template>
    <form @submit.prevent="submit()">
        <div class="form-group">
             <div class="form-group" >
                  <label for="" class="col-sm-2 control-label">Listado de Trámites Destacados</label>
                  <div  class="col-sm-10 panel panel-default">
                        <table class="table" width="90%">
                            <thead>
                                <tr>
                                    <th>Nombre Trámite</th>
                                    <!-- <th>Activo</th> -->
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in this.data.featuredPages">
                                    <td>{{item.title}}</td>
                                    <td> <a href="#"  @click.prevent="remove(item.pageId)" ><i class="material-icons">delete</i></a></td>
                                </tr>
                                <tr v-if="data.nrofeature < 3">
                                    <td>
                                        <el-select  v-model="data.pageId" placeholder="Seleccione página"  id="pagina" >
                                             <el-option
                                                 v-for="item in pagesOptions()"
                                                :key="item.id"
                                                :label="item.title"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </td>
                                   
                                    <td >
                                        <a href="#"  @click.prevent="addFeaturedPages"><i class="material-icons">add_circle</i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="help-block" v-for="e in errors['page']">{{e}}</div>
                  </div>
            </div>
            <div class="form-group" >
                <label for="" class="col-sm-2 control-label">Previsualización</label>
                <div id="home" class="col-sm-10 panel panel-default">
                    <div  class="categories-area categories-area2">
                        <div class="category category2">
                                <a class="heading collapsed" role="button" data-toggle="collapse" :href="'#categoryCollapse-'+ categorie.id " aria-expanded="false" aria-controls="categoryCollapse">
                                    <h3>{{categorie.name}} </h3>
                                    <span class="caret"></span>
                                </a>
                                <div class="category-body category-body2 collapse" v-bind:id="'categoryCollapse-'+ categorie.id ">
                                    <ul>
                                        <li v-for="p in data.finalmostvisited">
                                            <a :href="'fichas/'+ p.guid"  :title="p.title" data-ga-te-category="Tabs Fichas" data-ga-te-action="Ficha Mas Visitadas"  v-bind:data-ga-te-value="p.master_id">{{ p.title }} </a>
                                            <div v-if="p.online">Trámite en Línea</div>
                                        </li>
                                    </ul>
                                    <a class="btn" v-bind:href="'buscar?category='+ categorie.id " data-ga-te-category="Menu Accesos" data-ga-te-action="clic" v-bind:data-ga-te-value=" categorie.id ">Ir a {{categorie.name }}</a>
                                </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                    <div class="help-block" v-for="e in errors['msg']">{{e}}</div>
                    <a class="btn btn-default" :href="'backend/sections-home/'+ section.id +'/edit'" >Cancelar</a>
                    <button type="submit" class="btn btn-primary">Guardar</button>
                </div>
            </div>
        </div>
    </form>
</template>
<style  lang="scss" scoped>
.categories-area2{
    padding: 0!important;
    display: flex;
    justify-content: center;
}
.category2{
    margin-bottom: 20px!important;
}
.category-body2 ul{
    margin-bottom: -35px!important;
}

</style>
<script>


export default {

    data:function(){
        const featuredlist =  _.cloneDeep(this.featuredlist)
        var featuredPages= [];
        var finalmostvisited =_.cloneDeep(this.mostvisited);
        var nrofeature = 0;
        var pages = this.pages; 

        if(featuredlist.length>0){
            console.log("entre");
            featuredlist.forEach(function(e){
                 var featuredpage = new Object();
                    var page = pages.find(p => p.id === e.page_id);
                    var final = [];
    
                    featuredpage.pageId = page.id;
                    featuredpage.title = page.title;
                    featuredPages.push(featuredpage);
    
                    nrofeature ++;
                    finalmostvisited.unshift(page); 
                    finalmostvisited.pop();
    
            })
        }


        var data ={
            pageId:'',
            featuredPages:featuredPages,
            categorieId : this.categorie.id, 
            sectionId:this.section.id,
            nrofeature:nrofeature ,
            finalmostvisited: finalmostvisited
        }

        return{
            data:data,
            errors: {}
        }
    },
    props:['pages','section','categorie','mostvisited','featuredlist'],
    methods:{
        submit:function(){
             
            // if(this.data.featuredPages.length > 0){
                axios({
                    url: "backend/sections-home/featured"  ,
                    method: "PUT",
                    data: this.data
                })
                .then(response => {
                    window.location.replace(response.data.redirect);
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            // }else{
                // var errores = {};

                // errores['msg']= ["No existen trámites a destacar"];
                // this.errors = errores;
            // }
           
            
        },
        addFeaturedPages:function(){
            var errores = {};

            if(!this.data.pageId){
                errores['page']= ["Debe seleccionar una pagina a agregar"];
            }

            this.errors = errores;

            if(errores['page']){
                return false;
            }
            else{
                var featuredpage = new Object();
                var page = this.pages.find(p => p.id === this.data.pageId);
                var final = [];
                
                featuredpage.pageId = page.id;
                featuredpage.title = page.title;
                this.data.featuredPages.push(featuredpage);
                this.data.finalmostvisited.unshift(page); 
                this.data.finalmostvisited.pop();

                this.data.nrofeature ++;
                this.data.pageId = "";
                this.data.active = true;
            }
        },
        remove:function(e){
            var featuredPages = [];
            var finalmostvisited = [];
            var nrofeature = this.data.nrofeature;
            var mostvisited = this.mostvisited;
            var pages = this.pages ;
           

            this.data.featuredPages.forEach(function(f){
                if(f.pageId != e){
                    featuredPages.push(f);
                    var page =  pages.find(p => p.id === f.pageId);

                    finalmostvisited.push(page);
                    nrofeature ++;
                }
            })

            if(finalmostvisited.length < 3){
                var a = 3 - finalmostvisited.length;
                
                for( var x = 0; x < a;x++){
                     finalmostvisited.push(mostvisited[x]);
                }
            }

            this.data.finalmostvisited = finalmostvisited;
            this.data.featuredPages = featuredPages;
            this.data.nrofeature = nrofeature ;
        },
        pagesOptions:function(){
            var pages=[];
            var featuredPages = this.data.featuredPages;
            var mostVisited = this.mostvisited;


            this.pages.forEach(function(p){
                var ok = true;

                ok = mostVisited.find(e =>  e.id === p.id ||  e.master_id === p.id)? false : true;

                if(ok){
                    if(featuredPages.length > 0 )
                        ok = featuredPages.find(e => e.pageId === p.id)? false : true;
                }

                if(ok)
                        pages.push(p);
            });


            return pages;
        }
    }

}
</script>
